
import React, { useMemo, useRef } from 'react';
import { Card, ListView, Flex } from 'antd-mobile';
import { Error, Loading } from '.';
import { renderDeductTypes } from "../../../utils/utils"
import { getSmsType } from '../../localStorage';

const dataSource = new ListView.DataSource({
  rowHasChanged: (row1, row2) => row1 !== row2,
});

function CustomerList(props) {

  const { loading, errorMessage, companyList, handleAction } = props;
  const listRef = useRef()
  const smsType = getSmsType();

  const dataSourceList = useMemo(() => dataSource.cloneWithRows(companyList), [companyList])

  const row = (item) => {
    return <Card key={item.CompanyId} style={{ marginBottom: '10px' }}>
      <Card.Header
        title={item.CompanyEmail || '邮箱不存在'}
        extra={<span className={smsType === 'EMAIL' ? 'text-light-grey' : 'text-primary'} onClick={smsType === 'EMAIL' ? () => {} : () => handleAction(item)}>操作</span>}
      />
      <Card.Body style={{ paddingBottom: '10px' }}>
        <Flex className='flex'>
          <Flex.Item className='description-title'>CompanyID</Flex.Item>
          <Flex.Item className='description-content'>{item.CompanyId || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>公司名称</Flex.Item>
          <Flex.Item className='description-content'>{item.CompanyName || '-'}</Flex.Item>
        </Flex>
        {/* <Flex className='flex'>
          <Flex.Item className='description-title'>行业</Flex.Item>
          <Flex.Item className='description-content'>{item.IndustryTagId || '-'}</Flex.Item>
        </Flex> */}
        <Flex className='flex'>
          <Flex.Item className='description-title'>付费类型</Flex.Item>
          <Flex.Item className='description-content'>{renderDeductTypes(item)}</Flex.Item>
        </Flex>
      </Card.Body>
      {/* <Card.Footer
        content={
          item.Upgrade === 1 ?
            <Badge text={"已升级"} style={{ backgroundColor: '#21b68a' }} /> :
            <Badge text={"未升级"} hot />}
        extra={<div>{`${formatDate(item.RegistrationTime) || '-'}`}</div>}
      /> */}
    </Card>
  }

  return (
    <Loading loading={loading}>
      {errorMessage ?
        <Error message={errorMessage} /> : <>
          <ListView
            ref={listRef}
            initialListSize={5}
            dataSource={dataSourceList}
            renderRow={row}
            style={{
              height: '500px',
              overflowY: 'auto'
            }}
            pageSize={5}
            scrollRenderAheadDistance={200}
          />
        </>
      }
    </Loading>
  )
}

export default CustomerList